// src\themes\default\elements\footer\Footer.tsx
import SelectLanguage from '@/components/account/SelectLanguage';
import Container from '@/components/shared/Container';
import { Separator } from '@/components/ui/separator';
import { getFooterItems } from '@/core/lib/api/main/menu-api';

import FooterList from './FooterList';
import Newsletter from './Newsletter';
import SocialMedia from './SocialMedia';
import Link from 'next/link';
import Image from 'next/image';
import { getSettings } from '@/core/lib/api/main/setting';

export default async function Footer() {
  const footerItems = await getFooterItems();
  const setting = await getSettings();
  console.log(setting);




  return (
    <div className='border-t border-primary-500 mt-10'>
      <Container className="py-8 print:hidden space-y-8">
        <Newsletter />
        <div className='flex justify-between items-center w-full'>
          <Link
            href="/"
            className="h-full w-full md:w-2/12"
          >
            {setting.logo_footer && (
              <Image
                src={setting.logo_footer}
                alt={setting.site_title || "Logo"}
                width={140}
                height={70}
                className="object-contain flex"
              />
            )}
          </Link>
          <SocialMedia />
        </div>
        <Separator />
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12">
            <FooterList footerItems={footerItems} setting={setting} />
          </div>
        </div>
        <Separator />

        <div className="flex items-center justify-center">
          <SelectLanguage />
        </div>

      </Container>
    </div>
  );
}
